<template>
  <zen-one :showuserinfo="true" :title="'SENARAI AI Man'">
    <z-page class="white--bg mt3 sh2" :title="'Paparan Senarai AI Man'">
      <div class="w-card__content content-hardcode mb3">
        <w-form v-model="valid" @validate="cari" ref="frm">
          <w-flex class="mt3">
            <w-input style="margin:5px;" class="mt4" v-model="carian_aiman.name" label="Nama AI Man" />
            <z-select style="margin:5px;" v-model="carian_aiman.lkp_negeri_id" :items="lkp_negeri" label="Negeri" />
          </w-flex>
        </w-form>
        <w-flex justify-end class="mt2">
          <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
            <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA
          </w-button>
          <w-button class="mr2" bg-color="primary" @click="setCarianAiman()">
            <w-icon>fal fa-search</w-icon>&nbsp;CARI
          </w-button>
        </w-flex>
      </div>

      <div class="w-flex wrap smd-column">
        <div class="admin-scrol">
          <div v-if="aiman_datas.data && aiman_datas.data.length === 0" class="no-records">
            <h3>Tiada Rekod Ditemukan</h3>
          </div>
          <div class="dashboard3">
            <div class="cardadmin" v-for="(dt, index) in aiman_datas.data">
              <div class="card-infoadmin">
                <span><h2>{{ dt.label }}</h2></span>
              </div>
              <div class="card-infoadmin">
                <span style="color: black"><p style="margin-top: 40px;">{{ dt.email }}</p></span>
                <span style="color: black"><p>{{ dt.no_tel }}</p></span>
                <span style="color: black"><p>{{ dt.negeri }}</p></span>
                <span style="color: black"><p>{{ dt.cawangan }}</p></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <w-flex v-if="aiman_datas.data && aiman_datas.data.length > 0" justify-end class="mt2 pagination-container">
        <template v-for="(link, index) in aiman_datas.links" :key="index">
          <w-button
            bg-color="grey-light5--bg"
            class="pagination-button"
            :class="{ active: link.active }"
            @click="pageAiman(link)"
            :disabled="!link.url || link.active"
          >
            {{ link.label }}
          </w-button>
        </template>
      </w-flex>
    </z-page>
  </zen-one>
</template>

<script>
export default {
  props: {
    auth: [Array, Object],
  },
  components: {},
  data() {
    return {
      errors: [],
      aiman_datas: [],
      lkp_negeri: [],
      carian_aiman: {
        lkp_negeri_id: '',
        name: ''
      },
      cari_aiman: {
        lkp_negeri_id: '',
        name: ''
      },
      crumbs: [
        { label: this.$page.props.app_name, route: '/senarai_aiman' },
      ],
      tahun: [],
    }
  },
  methods: {


      getaimanSenarai(page){
         this.$zcomm.get(this.api_service + 'lookup/aiman_senarai?name='+this.cari_aiman.name+'&lkp_negeri_id='+ this.cari_aiman.lkp_negeri_id+'&page='+page, {}).then(res => {
           this.aiman_datas = res
         })
     },

    resetPencarian() {
      this.carian_aiman.lkp_negeri_id = ''
      this.carian_aiman.name = ''
      this.setCarianAiman()
    },
    setCarianAiman() {
      this.cari_aiman.lkp_negeri_id = this.carian_aiman.lkp_negeri_id
      this.cari_aiman.name = this.carian_aiman.name
      this.getaimanSenarai(1)
    },
    pageAiman(link) {
    if (!link.url || link.active) return;
    
    let page;
    
    switch(link.label) {
      case 'Seterusnya':
        page = this.aiman_datas.current_page + 1;
        break;
      case 'Sebelum':
        page = this.aiman_datas.current_page - 1;
        break;
      default:
        // Untuk angka halaman (1, 2, 3, dst)
        page = parseInt(link.label);
    }
    
    if (page) {
      this.getaimanSenarai(page);
    }
  },
    getNegeri() {
      this.$zcomm.get(this.api_service + 'lookup/negeri_aiman', {}).then(res => {
        this.lkp_negeri = res
      })
    },
  },
  mounted() {
    this.getaimanSenarai()
    this.getNegeri()
  }
}
</script>

<style>
.w-card {
  z-index: 9;
}

.dashboard3 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 70px;
  padding: 20px;
  background-color: #f5f5f5;
}

.cardadmin {
  background: url(/images/aimans.png) center / cover no-repeat;
  border-radius: 15px;
  box-shadow: -10px 16px 14px 4px rgb(0 0 0 / 17%);
  padding: 20px;
  width: 400px;
  height: 250px;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
}

.cardadmin:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  justify-content: center;
}

.card-infoadmin h2 {
  margin-top: 47px;
  margin-left: -10px;
  font-size: 14px;
  font-family: "Gill Sans Extrabold", sans-serif;
  padding: 5px;
  font-weight: bold;
  color: white;
  letter-spacing: 1px;
}

.card-infoadmin h1 {
  margin-top: 10px;
  margin-left: 30px;
  font-size: 14px;
  font-family: "Gill Sans Extrabold", sans-serif;
  padding: 5px;
  font-weight: bold;
  color: #204288;
}

.pagination-container {
  gap: 5px;
  flex-wrap: wrap;
}

.pagination-button {
  min-width: 40px;
  margin: 2px;
}

.no-records {
  text-align: center;
  padding: 50px;
  font-size: 18px;
  color: #666;
  background-color: #f5f5f5;
  border-radius: 10px;
  margin: 20px;
}

.pagination-button.active {
  background-color: #1976d2 !important;
  color: white !important;
  font-weight: bold;
}

.pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.card-infoadmin p {
  font-size: 12px;
  font-weight: bold;
  color: black;
  padding-top: 8px;
  margin-left: 15px;
}
</style>